import React from 'react';

export interface IWFNXTitleBarProps {
  className?: string;
  children?: React.ReactNode;
}

export class WFNXTitleBar extends React.Component<IWFNXTitleBarProps, any> {
  render() {
    const { className, children } = this.props;
    const classnames = `wfnx-titleBar ${className}`;

    return (
      <div className={classnames}>{children}</div>
    );
  }
}
